<template>
  <ContentPage>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        Badges & Bragging Rights
      </div>
    </template>

    <BadgesCard />
    
  </ContentPage>
</template>

<script>
  import BadgesCard from './BadgesCard'
  import { ContentPage } from '@/components/pages'

  export default {
    name: 'BadgesView',

    components: { BadgesCard, ContentPage },
  }
</script>
